'use es6';

import getIn from 'transmute/getIn';

// companies are allowed to have no name or domain
export const formatCompanyName = company => getIn(['properties', 'name', 'value'], company) || getIn(['properties', 'domain', 'value'], company) || '';